// extracted by mini-css-extract-plugin
module.exports = {"brandPrimary":"#26b67c","brandPrimaryDarker":"#0e5338","brandSecondary":"#4d2079"};